import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import { useRef } from 'react';
import { S3Video } from '@/components/s3/s3-video';
import { videoModalContainer, videoModalVideo } from './learning-center.css';

type VideoModalProps = {
  s3Key: string;
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onEnded?: () => void;
};

export const VideoModal = ({
  s3Key,
  title,
  open,
  onOpenChange,
  onEnded,
}: VideoModalProps) => {
  const maxTimeRef = useRef(0);

  const handleTimeUpdate = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    const video = e.target as HTMLVideoElement;

    if (!video.seeking) {
      maxTimeRef.current = Math.max(maxTimeRef.current, video.currentTime);
    }
  };

  const handleSeeking = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    const video = e.target as HTMLVideoElement;
    if (video.currentTime > maxTimeRef.current + 1) {
      video.currentTime = maxTimeRef.current;
    }
  };

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalContent className={videoModalContainer}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <S3Video
          className={videoModalVideo}
          path={s3Key}
          controls
          controlsList="nodownload"
          disablePictureInPicture
          disableRemotePlayback
          autoPlay
          onTimeUpdate={handleTimeUpdate}
          onSeeking={handleSeeking}
          onEnded={onEnded}
        />
      </ModalContent>
    </ModalRoot>
  );
};
